import {useState} from 'react';
import {Alert, Button, Input} from '@vector';
import {requestFreeTrial} from '../homeService';
import {getRecaptchaToken} from '../../portal/recaptcha';
import styles from './TrialPanel.module.css';

/**
 * Fork of `sections/FreeTrial.js` for the redesigned card look - same `requestFreeTrial` call and
 * accessibility pattern, restyled into the mock's orange card with a pill email+button compound.
 * `sections/FreeTrial.js` itself is untouched, since `Home.js` still renders it directly.
 */
export default function TrialPanel({id, content, trialDays}) {
    const [email, setEmail] = useState('');
    const [busy, setBusy] = useState(false);
    const [result, setResult] = useState(null);

    const submit = async (event) => {
        event.preventDefault();
        setBusy(true);
        setResult(null);

        try {
            const recaptchaToken = await getRecaptchaToken('freeTrial');
            setResult(await requestFreeTrial({email, recaptchaToken}));
        } catch (e) {
            setResult({sent: false, message: 'We could not start your trial. Please try again in a moment.'});
        } finally {
            setBusy(false);
        }
    };

    const heading = trialDays ? `Get a ${trialDays}-day trial` : content.heading;

    return (
        <div id={id} className={styles.card}>
            <span className={styles.eyebrow}>{content.sectionHeading}</span>
            <h2 className={styles.heading}>{heading}</h2>
            <p className={styles.body}>{content.body}</p>

            <form className={styles.form} onSubmit={submit}>
                <label className={styles.fieldLabel} htmlFor="home-trial-email">Email address</label>
                <div className={styles.row}>
                    <Input
                        id="home-trial-email"
                        type="email"
                        required
                        autoComplete="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="you@example.com"
                    />
                    <Button surface="inverse" htmlType="submit" loading={busy}
                            className={styles.submitButton}>
                        Get trial
                    </Button>
                </div>
            </form>

            <div role="status" aria-live="polite">
                {result && (
                    <Alert
                        className={styles.alert}
                        type={result.sent ? 'success' : 'error'}
                        message={result.message}
                        showIcon
                    />
                )}
            </div>

            {content.teacherNote && <p className={styles.hint}>{content.teacherNote}</p>}
        </div>
    );
}
